'use client';

var translation = {
    '/management-jobs': '/viec-lam-quan-ly',
    New: 'Mới',
    Matching: 'Phù hợp'
};

export { translation as default };
//# sourceMappingURL=translation.js.map
